import { Box, Button, Card, Flex, Heading, Text } from "rebass/styled-components"
import { ICustomerSatisfaction, IGetDashboardCardsDataOutput, IServedPerDay } from "../../graphql/types/queries/dashboard"
import { IGetUpcominsOutput } from "../../graphql/types/queries/appointment"
import withSession, { IWithSession } from "../../lib/withSession"
import { Skeleton } from "../../components/loadingSkeleton/Skeleton"
import { PropsWithChildren, useContext, useEffect, useState } from "react"
import { OpenedConversationsContext } from "../../contexts/openConversationsCounts"
import { Area, AreaChart, CartesianGrid, Legend, ResponsiveContainer, XAxis, YAxis } from "recharts"
import moment from "moment"
import { useNavigate } from "react-router"
import styled from "styled-components"
import Modal from "styled-react-modal"
import { SpecialModalBackground } from "../../components/Commons"
interface IProps {
  dataDashboardCards: IGetDashboardCardsDataOutput | undefined,
  loadingDashboardCards: boolean,
  dataUpcoming: IGetUpcominsOutput | undefined
  loadingUpcoming: boolean
}

const Wrapper = styled(Flex)`
overflow: hidden;
width: 100%;
padding-right: 20px;
margin-right: 20px;
  &:hover {
    overflow-y: auto;
  }
&::-webkit-scrollbar-track {
  background: transparent;
}
&::-webkit-scrollbar-thumb {
  background: #6c89b7;
  border-radius: 5px;
}
    &::-webkit-scrollbar {
        width: 7px;
        border: 1px solid transparent;
    }
`

const TopCard: React.FC<{ count?: number | null, text: string, loading?: boolean, onClick?: () => void, countMr?: number, description?: string } & PropsWithChildren> = ({ count, children, text, loading, onClick, countMr = 2, description }) => {
  const [isShowDescription, setIsShowDescription] = useState(false)
  return (
    <Card paddingY={['8px', '30px', '30px']} paddingX={'26px'} marginBottom={['8px', 0, 0]} marginRight={[0, '32px', '32px']} style={{ flex: 'initial', cursor: !!onClick ? 'pointer' : '', position: 'relative' }} onClick={() => {
      if (!!onClick) {
        onClick()
      }
    }}>
      <Flex alignItems={'center'}>
        {loading ? (
          <Skeleton height={27} width={40} />
        ) : (
          <Flex alignItems={'baseline'}>
            <Heading mr={countMr}>{count}</Heading>
            {children}
          </Flex>
        )}
      </Flex>
      <Text mt={2} style={{ fontWeight: 400, color: 'rgba(52, 79, 122, 0.6)', fontSize: '14px' }}>{text}</Text>
      {!!description && (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ position: 'absolute', top: 12, right: 12, opacity:0.5 }} onClick={() => setIsShowDescription(true)}>
          <path d="M13.125 16.875C13.125 17.0975 13.059 17.315 12.9354 17.5C12.8118 17.685 12.6361 17.8292 12.4305 17.9144C12.225 17.9995 11.9988 18.0218 11.7805 17.9784C11.5623 17.935 11.3618 17.8278 11.2045 17.6705C11.0472 17.5132 10.94 17.3127 10.8966 17.0945C10.8532 16.8762 10.8755 16.65 10.9606 16.4445C11.0458 16.2389 11.19 16.0632 11.375 15.9396C11.56 15.816 11.7775 15.75 12 15.75C12.2984 15.75 12.5845 15.8685 12.7955 16.0795C13.0065 16.2905 13.125 16.5766 13.125 16.875ZM12 6.75C9.93188 6.75 8.25 8.26406 8.25 10.125V10.5C8.25 10.6989 8.32902 10.8897 8.46967 11.0303C8.61033 11.171 8.80109 11.25 9 11.25C9.19892 11.25 9.38968 11.171 9.53033 11.0303C9.67099 10.8897 9.75 10.6989 9.75 10.5V10.125C9.75 9.09375 10.7597 8.25 12 8.25C13.2403 8.25 14.25 9.09375 14.25 10.125C14.25 11.1562 13.2403 12 12 12C11.8011 12 11.6103 12.079 11.4697 12.2197C11.329 12.3603 11.25 12.5511 11.25 12.75V13.5C11.25 13.6989 11.329 13.8897 11.4697 14.0303C11.6103 14.171 11.8011 14.25 12 14.25C12.1989 14.25 12.3897 14.171 12.5303 14.0303C12.671 13.8897 12.75 13.6989 12.75 13.5V13.4325C14.46 13.1184 15.75 11.7544 15.75 10.125C15.75 8.26406 14.0681 6.75 12 6.75ZM21.75 12C21.75 13.9284 21.1782 15.8134 20.1068 17.4168C19.0355 19.0202 17.5127 20.2699 15.7312 21.0078C13.9496 21.7458 11.9892 21.9389 10.0979 21.5627C8.20656 21.1865 6.46928 20.2579 5.10571 18.8943C3.74215 17.5307 2.81355 15.7934 2.43735 13.9021C2.06114 12.0108 2.25422 10.0504 2.99218 8.26884C3.73013 6.48726 4.97982 4.96452 6.58319 3.89317C8.18657 2.82183 10.0716 2.25 12 2.25C14.585 2.25273 17.0634 3.28084 18.8913 5.10872C20.7192 6.93661 21.7473 9.41498 21.75 12ZM20.25 12C20.25 10.3683 19.7662 8.77325 18.8596 7.41655C17.9531 6.05984 16.6646 5.00242 15.1571 4.37799C13.6497 3.75357 11.9909 3.59019 10.3905 3.90852C8.79017 4.22685 7.32016 5.01259 6.16637 6.16637C5.01259 7.32015 4.22685 8.79016 3.90853 10.3905C3.5902 11.9908 3.75358 13.6496 4.378 15.1571C5.00242 16.6646 6.05984 17.9531 7.41655 18.8596C8.77326 19.7661 10.3683 20.25 12 20.25C14.1873 20.2475 16.2843 19.3775 17.8309 17.8309C19.3775 16.2843 20.2475 14.1873 20.25 12Z" fill="black" />
        </svg>

      )}
      {isShowDescription && (
         <Modal
         isOpen={true}
         onBackgroundClick={() => {
           setIsShowDescription(false)
         }}
         onEscapeKeydown={() => {
          setIsShowDescription(false)
         }}
       >
         <SpecialModalBackground
           onClick={() => {
            setIsShowDescription(false)
           }}
         >
           <Box
             style={{
               margin: '0 auto',
               alignSelf: 'center',
               borderRadius: '20px',
               position: 'relative',
               background: 'linear-gradient(180deg, #BBD4ED 0%, #FDF5F2 100%)',
               padding: '24px',
               display: 'flex',
               justifyContent: 'center',
               alignItems: 'center',
               flexDirection: 'column',
               maxWidth: '95vw',
               minWidth: 'initial',
               maxHeight: '95vh',
               overflowY: 'hidden',
             }}
             onClick={(e) => {
               // e.preventDefault();
               e.stopPropagation();
             }}
           >
             <Flex flex={1} flexDirection={'column'} width={'800px'} style={{ overflowY: 'auto', alignItems:'center', justifyContent:'center' }}>
               <Heading mb={4} textAlign={'center'}>{text}</Heading>
               <Text mb={4} textAlign={'center'}>{description}</Text>
               <Button variant={'primary'} onClick={()=>setIsShowDescription(false)}>OK</Button>
             </Flex>
           </Box>
         </SpecialModalBackground>
       </Modal>
      )}
    </Card>
  )
}

const YourMetrics: React.FC<IProps & IWithSession> = ({
  dataDashboardCards,
  loadingDashboardCards,
  dataUpcoming,
  loadingUpcoming,
  session: { calendlyUserId, helpscoutId }
}) => {
  const navigate = useNavigate()
  const [onboardingCallsThisMonth, setOnboardingCallsThisMonth] = useState<number | null>()
  const [onboardingCallsLastMonth, setOnboardingCallsLastMonth] = useState<number | null>()
  const [onboardingCallsFuture, setOnboardingCallsFuture] = useState<number | null>()
  const openedConversationsCount = useContext(OpenedConversationsContext)
  const [underCare, setUnderCare] = useState<number | null>()
  const [activeHealthCoaching, setactiveHealthCoaching] = useState<number | null>()
  const [totalAssignedConvos, settotalAssignedConvos] = useState<number | null>()
  const [handleTime, sethandleTime] = useState<number | null>()
  const [servedLast7Days, setServedLast7Days] = useState<number | null>()
  const [customerSatisfaction, setCustomerSatisfaction] = useState<ICustomerSatisfaction | null>()
  const [membersHelpedPerDay, setMembersHelpedPerDay] = useState<Array<{
    day: string,
    month: string,
    customers: number,
    date: string
  }> | null>()

  useEffect(() => {
    if (!!loadingDashboardCards) return

    if (!!dataDashboardCards?.getHealthCoachDashboardCardsData.onboardingCallThisMonth) {
      setOnboardingCallsThisMonth(dataDashboardCards?.getHealthCoachDashboardCardsData.onboardingCallThisMonth)
    }
    if (!!dataDashboardCards?.getHealthCoachDashboardCardsData.onboardingCallLastMonth) {
      setOnboardingCallsLastMonth(dataDashboardCards?.getHealthCoachDashboardCardsData.onboardingCallLastMonth)
    }
    if (!!dataDashboardCards?.getHealthCoachDashboardCardsData.onboardingCallFuture) {
      setOnboardingCallsFuture(dataDashboardCards?.getHealthCoachDashboardCardsData.onboardingCallFuture)
    }
    if (!!dataDashboardCards?.getHealthCoachDashboardCardsData.underCare) {
      setUnderCare(dataDashboardCards?.getHealthCoachDashboardCardsData.underCare)
    }
    if (!!dataDashboardCards?.getHealthCoachDashboardCardsData.servedLast7Days) {
      setServedLast7Days(dataDashboardCards?.getHealthCoachDashboardCardsData.servedLast7Days)
    }

    if (!!dataDashboardCards?.getHealthCoachDashboardCardsData.activeHealthCoaching) {
      setactiveHealthCoaching(dataDashboardCards?.getHealthCoachDashboardCardsData.activeHealthCoaching)
    }
    if (!!dataDashboardCards?.getHealthCoachDashboardCardsData.totalAssignedConvos) {
      settotalAssignedConvos(dataDashboardCards?.getHealthCoachDashboardCardsData.totalAssignedConvos)
    }
    if (!!dataDashboardCards?.getHealthCoachDashboardCardsData.handleTime) {
      sethandleTime(dataDashboardCards?.getHealthCoachDashboardCardsData.handleTime)
    }
    // if (!!dataDashboardCards?.getHealthCoachDashboardCardsData.customerSatisfaction) {
    //   setCustomerSatisfaction(dataDashboardCards?.getHealthCoachDashboardCardsData.customerSatisfaction)
    // }
    if (!!dataDashboardCards?.getHealthCoachDashboardCardsData.servedPerDay) {
      setMembersHelpedPerDay(dataDashboardCards?.getHealthCoachDashboardCardsData.servedPerDay.map(x => {
        return {
          day: moment(x.date).format('DD'),
          month: moment(x.date).format('MMMM'),
          customers: x.customers,
          date: x.date
        }
      }
      ))
    }
  }, [dataDashboardCards, loadingDashboardCards])

  const renderQuarterTick = (tickProps: any): any => {
    const { x, y, payload } = tickProps;
    const { value, offset } = payload;
    if (!membersHelpedPerDay) return
    // console.log({ value, offset })
    // const date = new Date(value);
    const month = moment(value).format('MMMM');
    const day = moment(value).format('DD')
    const inMonth = membersHelpedPerDay?.filter(x => x.month === month)
    const a = (inMonth || []).length / 2
    // console.log({ inMonth, a })
    const cutDay = inMonth[Math.round(a)]

    if (cutDay && cutDay.day && day === cutDay.day) {
      return <text x={x} y={y - 4} textAnchor="middle" fontSize={12} fill='rgb(99, 99, 99)'
      >{`${month}`}</text>;
    }

    const isLast = moment(value).endOf('month').format('MM/DD/YYYY') === moment(value).format('MM/DD/YYYY');

    if (isLast) {
      const pathX = Math.floor(isLast ? x + offset : x - offset) + 1;

      return <path d={`M${pathX},${y - 4}v${-35}`} stroke="#EBECEF" />;
    }
    return null;
  };

  return (
    <Flex flexDirection={'column'} style={{
      width: '100%',
      paddingRight: '20px',
      marginRight: '20px',
    }}>
      <Heading mb={4}>Your Metrics</Heading>

      <Wrapper flexDirection={'column'} >
        <Heading fontSize={'18px'} mb={2}>Onboarding Calls</Heading>
        {!calendlyUserId ? (
          <Text fontWeight={300} opacity={0.75} textAlign={'center'} mb={4}>You don't have a calendly user id set</Text>
        ) : (
          <Flex mb={4}>
            <TopCard loading={loadingDashboardCards} count={onboardingCallsThisMonth} text='onboarding calls this month'>
              {!loadingDashboardCards && onboardingCallsThisMonth && onboardingCallsLastMonth &&
                (<Box style={{ background: (onboardingCallsThisMonth) - (onboardingCallsLastMonth) > 0 ? '#BCFFEB' : 'rgba(248, 162, 148, 0.43)', display: 'flex', alignItems: 'center', alignSelf: 'center', borderRadius: '10px', padding: '0 12px', height: '24px' }}>
                  <Text fontSize={'12px'} color={(onboardingCallsThisMonth) - (onboardingCallsLastMonth) > 0 ? '#4AA98C' : ''}>{(onboardingCallsThisMonth) - (onboardingCallsLastMonth) > 0 ?
                    `+${(onboardingCallsThisMonth) - (onboardingCallsLastMonth)}` :
                    (onboardingCallsThisMonth) - (onboardingCallsLastMonth)} </Text>
                </Box>)}
            </TopCard>
            <TopCard loading={loadingDashboardCards} count={onboardingCallsFuture} text='Future onboarding calls' />
          </Flex>
        )}
        {/* <Heading fontSize={'18px'} mb={2}>Memberships</Heading> */}
        <Flex mb={4}>
          <TopCard loading={loadingDashboardCards} count={activeHealthCoaching} text='HC enabled' description="Count of all patients having the Health Coaching toggle on. (All Health Coaches)"/>
        </Flex>
        <Heading fontSize={'18px'} mb={2}>Conversations</Heading>
        <Flex mb={3}>
          <TopCard count={openedConversationsCount} text='open patient conversations' onClick={() => {
            navigate('/messages')
          }} />
          <TopCard loading={loadingDashboardCards} count={servedLast7Days} text='served in the last 7 days' />
        </Flex>
        <Flex mb={4}>
          <TopCard loading={loadingDashboardCards} count={totalAssignedConvos} text='Total assigned convos' description="Total count of HS conversation in Member mailbox assigned to you. (opened and closed)"/>
          <TopCard loading={loadingDashboardCards} count={handleTime} text='Handle Time (7 days)' description="Statistics about the amount of time between opening the conversation and pressing the Send button; if you save a draft and come back to visit it several times, only the final visit before sending will be captured as the handle time. (All Health Coaches)" />
        </Flex>
        {/* <Flex mb={3}>
          <TopCard countMr={0} loading={loadingDashboardCards} count={customerSatisfaction ? customerSatisfaction.happinessScore : 0} text='Happiness Satisfaction'>
            <Text>% / {customerSatisfaction?.ratingsCount} ratings</Text>
          </TopCard>
        </Flex> */}
        {!!membersHelpedPerDay && (
          <Card width={'100%'} pt='20px'
            pb={3} paddingX={'26px'} >
            <Flex flexDirection={'column'}>

              <Text mb={3} style={{ fontWeight: 400, color: 'rgba(52, 79, 122, 0.6)', fontSize: '14px' }}>Members helped per day</Text>
              <ResponsiveContainer width={'100%'}
                aspect={2}>
                <AreaChart
                  data={membersHelpedPerDay}
                  margin={{
                    top: 0,
                    right: 10,
                    left: -30,
                    bottom: 0,
                  }}
                >
                  <defs>
                    <linearGradient id={`colorUv`} x1="0.5" y1="0" x2="0.5" y2="1">
                      <stop offset="5%" stopColor={'#1e46d4'} stopOpacity={0.5} />
                      <stop offset="95%" stopColor={'#1e46d4'} stopOpacity={0.1} />
                      {/* <stop offset="100%" stopColor={colors.bg2} stopOpacity={colors.op2} />
              <stop offset="50%" stopColor={colors.bg} stopOpacity={colors.op1} /> */}
                    </linearGradient>
                  </defs>
                  <CartesianGrid strokeDasharray="3 3" />
                  <Legend fill={'white'} />
                  <XAxis xAxisId={0} label={{ value: '', angle: 0, position: 'bottom' }} dataKey="day" tickLine={false} tick={{ fontSize: 9, fontWeight: 300 }} />
                  <XAxis
                    xAxisId={1}
                    axisLine={false}
                    tickLine={false}
                    interval={0}
                    tick={renderQuarterTick}
                    height={1}
                    dataKey={'date'}
                    scale="band"
                  // tick={renderQuarterTick}
                  // allowDuplicatedCategory={false} 
                  />

                  {/* <Tooltip content={<CustomizedTooltip />} /> */}
                  <YAxis tick={{ fontSize: 9, fontWeight: 300 }} tickLine={true} />
                  <Area type="monotone" dataKey="customers" stroke={'#1e46d4'} fillOpacity={1} fill={`url(#colorUv)`} />
                </AreaChart>
              </ResponsiveContainer>
            </Flex>
          </Card>
        )}
        <Box minHeight={'50px'} height={50}></Box>
      </Wrapper>
    </Flex>
  )
}

export default withSession(YourMetrics)